export default __webpack_public_path__ + "static/steffi-416c3ccc3cf2b37151fd978a51454150.svg";